// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1Cmr3","inputWrap":"CustomTip_inputWrap__2fEAV"};